import { render } from "./SeragamView.vue?vue&type=template&id=d066cebe"
import script from "./SeragamView.vue?vue&type=script&lang=js"
export * from "./SeragamView.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__